export default __webpack_public_path__ + "static/media/hero-image-6.1a9f0779.svg";